export default __webpack_public_path__ + "static/media/philadelphiaEagles@2x.c95cc915.jpg";